/* ==========================================================================
   Pierre Blanc — site script
   No animation libraries and no scroll smoothing: every page scrolls with the
   browser's own native scrolling. The ONE piece of motion on the site is the
   stacked hero: one wheel/trackpad gesture, one swipe or one key press moves
   exactly one frame. After the last frame the page scrolls normally.

   Fail-safe: without this script the frames simply stack and scroll.
   ========================================================================== */
(function () {
  'use strict';

  var W = window, D = document, root = D.documentElement;
  if (W.PBMotion && W.PBMotion.__booted) { W.PBMotion.refresh(); return; }

  var REDUCED = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var listeners = [];
  function on(el, ev, fn, opt) { el.addEventListener(ev, fn, opt); listeners.push([el, ev, fn, opt]); }
  function teardown() {
    listeners.forEach(function (l) { try { l[0].removeEventListener(l[1], l[2], l[3]); } catch (e) {} });
    listeners = []; scrollSubs = [];
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* One passive scroll listener, at most one callback run per frame. */
  var scrollSubs = [], ticking = false;
  function onScroll(fn) { scrollSubs.push(fn); }
  function flush() { ticking = false; for (var i = 0; i < scrollSubs.length; i++) scrollSubs[i](); }
  function scrolled() { if (!ticking) { ticking = true; requestAnimationFrame(flush); } }

  /* Instant programmatic scroll, even though pb-base.css sets scroll-behavior:smooth
     for anchor links (a smooth scrollTo per animation frame would lag behind). */
  function jump(y) {
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    W.scrollTo(0, y);
    root.style.scrollBehavior = prev;
  }

  /* ================= STACKED HERO ================= */
  var heroEnd = 0;   // bottom of the hero, measured by the header

  function initHero() {
    var stack = D.querySelector('[data-hstack]');
    if (!stack || stack.dataset.pbBound) return;
    var slides = Array.prototype.slice.call(stack.querySelectorAll('.hslide'));
    var n = slides.length;
    if (n < 2 || REDUCED) return;               // reduced motion: plain vertical stack
    stack.dataset.pbBound = '1';
    stack.classList.add('is-stacked');

    var vp = stack.querySelector('.hstack__vp');
    var caps = slides.map(function (s) { return Array.prototype.slice.call(s.querySelectorAll('.hslide__cap > *')); });
    var vh = 0, top = 0, lastW = W.innerWidth, lastP = null;

    // Each frame owns exactly one screen of scroll, in px from innerHeight, so the
    // pager's stops line up exactly with frame boundaries (on phones 100vh != innerHeight).
    function size() {
      vh = W.innerHeight;
      stack.style.height = (n * vh) + 'px';
      if (vp) vp.style.height = vh + 'px';
      top = stack.getBoundingClientRect().top + W.pageYOffset;
    }

    // Scroll position -> frame transforms. p runs 0..n-1; frame j rises over p in [j-1, j]
    // and is then pushed up 14% and scaled 5% while frame j+1 covers it.
    function render() {
      var p = clamp((W.pageYOffset - top) / vh, 0, n - 1);
      if (p === lastP) return;
      lastP = p;
      for (var j = 0; j < n; j++) {
        var inn = j === 0 ? 1 : clamp(p - (j - 1), 0, 1);
        var out = clamp(p - j, 0, 1);
        var y = out > 0 ? -14 * out : 100 * (1 - inn);
        slides[j].style.transform = 'translate3d(0,' + y.toFixed(3) + '%,0)' + (out > 0 ? ' scale(' + (1 + 0.05 * out).toFixed(4) + ')' : '');
        if (j > 0) {
          for (var c = 0; c < caps[j].length; c++) {
            var o = clamp((inn - 0.45 - 0.04 * c) / 0.4, 0, 1);
            caps[j][c].style.opacity = o;
            caps[j][c].style.transform = o < 1 ? 'translate3d(0,' + (16 * (1 - o)).toFixed(2) + 'px,0)' : '';
          }
        }
      }
    }

    size(); render();

    // A link to an anchor below the hero (e.g. /#journal from another page) was resolved
    // before the frames were sized; land on it again now that the layout is final.
    if (location.hash.length > 1) {
      var target = null;
      try { target = D.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
      if (target && !stack.contains(target)) {
        var prevSB = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto'; target.scrollIntoView(); root.style.scrollBehavior = prevSB;
      }
    }

    // ---------- paging ----------
    var busy = false, quiet = true, quietTimer = null, anim = 0;
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var hush = function () { quiet = false; clearTimeout(quietTimer); quietTimer = setTimeout(function () { quiet = true; }, 160); };
    var lastStop = function () { return top + vh * (n - 1); };
    var inHero = function (y) { return y >= top - 2 && y <= lastStop() + 2; };
    var idx = function (y) { return Math.round((y - top) / vh); };

    function goTo(k) {
      k = clamp(k, 0, n - 1);
      var from = W.pageYOffset, dist = top + vh * k - from;
      if (Math.abs(dist) < 2) return;
      busy = true;
      var dur = Math.max(250, Math.min(600, 600 * Math.abs(dist) / vh)), t0 = null;
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      cancelAnimationFrame(anim);
      (function step(t) {
        if (t0 === null) t0 = t;
        var e = Math.min(1, (t - t0) / dur);
        W.scrollTo(0, from + dist * ease(e));
        if (e < 1) anim = requestAnimationFrame(step);
        else { root.style.scrollBehavior = prev; busy = false; }
      })(performance.now());
    }

    // Wheel + trackpad. The rest of a gesture (including trackpad inertia) is swallowed
    // until the wheel has been quiet for 160ms, so one flick can never skip two frames.
    on(W, 'wheel', function (e) {
      if (e.ctrlKey) return;                                              // pinch-zoom
      var dy = e.deltaY;
      if (Math.abs(dy) < 1 || Math.abs(e.deltaX) > Math.abs(dy)) return;
      var y = W.pageYOffset, px = dy * (e.deltaMode === 1 ? 33 : e.deltaMode === 2 ? vh : 1);
      if (!inHero(y)) {
        // arriving from outside: land exactly on the nearest end frame first
        if (dy < 0 && y > lastStop() && y + px < lastStop()) { e.preventDefault(); hush(); goTo(n - 1); }
        else if (dy > 0 && y < top && y + px > top) { e.preventDefault(); hush(); goTo(0); }
        return;
      }
      if (busy || !quiet) { e.preventDefault(); hush(); return; }
      var k = idx(y) + (dy > 0 ? 1 : -1);
      if (k < 0 || k > n - 1) return;                                     // past either end: normal scroll
      e.preventDefault(); hush(); goTo(k);
    }, { passive: false });

    // Touch. Listeners sit on the hero only, so scrolling anywhere else on the page
    // stays fully passive. Whether a swipe pages is decided on its first 6px.
    var ty0 = null, decided = false, paging = false;
    on(stack, 'touchstart', function (e) {
      if (e.touches.length !== 1) { ty0 = null; return; }
      ty0 = e.touches[0].clientY; decided = false; paging = false;
    }, { passive: true });
    on(stack, 'touchmove', function (e) {
      if (ty0 === null) return;
      var dy = ty0 - e.touches[0].clientY;                                // > 0: finger up = scroll down
      if (!decided && Math.abs(dy) > 6) {
        decided = true;
        var y = W.pageYOffset;
        if (busy) paging = true;
        else if (inHero(y)) { var k = idx(y) + (dy > 0 ? 1 : -1); paging = k >= 0 && k <= n - 1; }
      }
      if (paging && e.cancelable) e.preventDefault();
    }, { passive: false });
    on(stack, 'touchend', function (e) {
      if (ty0 === null) return;
      var t = e.changedTouches && e.changedTouches[0], dy = ty0 - (t ? t.clientY : ty0);
      if (paging && !busy && Math.abs(dy) > 30) goTo(idx(W.pageYOffset) + (dy > 0 ? 1 : -1));
      ty0 = null;
    }, { passive: true });
    on(stack, 'touchcancel', function () { ty0 = null; }, { passive: true });

    // Keyboard: arrows, Page Up/Down and Space page through the frames too.
    on(D, 'keydown', function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (e.key === ' ' && t && /^(BUTTON|A|SUMMARY)$/.test(t.tagName)) return;
      var dir = { ArrowDown: 1, PageDown: 1, ArrowUp: -1, PageUp: -1 }[e.key] || (e.key === ' ' ? (e.shiftKey ? -1 : 1) : 0);
      if (!dir) return;
      var y = W.pageYOffset; if (!inHero(y)) return;
      var k = idx(y) + dir; if (k < 0 || k > n - 1) return;
      e.preventDefault(); if (!busy) goTo(k);
    });

    // Anything else that leaves the page resting between two frames (scrollbar drag,
    // momentum carried in from below, anchor jumps) settles on the nearest frame.
    var settleTimer = null;
    onScroll(function () {
      render();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (busy || ty0 !== null) return;
        var y = W.pageYOffset; if (!inHero(y)) return;
        var k = idx(y);
        if (Math.abs(top + vh * k - y) > 2) goTo(k);
      }, 140);
    });

    // Resize: keep the same frame. Phone URL-bar show/hide (height-only) is ignored so
    // the geometry never shifts mid-swipe.
    on(W, 'resize', function () {
      var w = W.innerWidth;
      if (w === lastW && W.matchMedia('(hover: none)').matches) return;
      lastW = w;
      var was = inHero(W.pageYOffset), k = idx(W.pageYOffset);
      size(); lastP = null; render();
      if (was) jump(top + vh * clamp(k, 0, n - 1));
    });

    // Theme editor: selecting a frame's block shows that frame.
    on(D, 'shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i >= 0) jump(top + vh * i);
    });

    // Frames 2-4 are lazy so they never compete with the first frame; fetch them as
    // soon as the page is up so every frame is ready before anyone pages to it.
    var warm = function () {
      slides.forEach(function (s) { var im = s.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; });
    };
    if (D.readyState === 'complete') setTimeout(warm, 100); else on(W, 'load', warm);
    setTimeout(warm, 2500);   // 'load' can be held open by third-party iframes
  }

  /* ================= HEADER =================
     Transparent over the hero, solid once past it (and always on pages without one). */
  function initHeader() {
    var header = D.querySelector('[data-pb-header]');
    if (!header) return;
    var measure = function () {
      // Either hero counts: the scroll-paged stack, or the crossfading campaign hero.
      var s = D.querySelector('[data-hstack], [data-campaign]');
      heroEnd = s ? s.getBoundingClientRect().bottom + W.pageYOffset : 0;
    };
    var update = function () { header.classList.toggle('pb-scrolled', W.pageYOffset > heroEnd - 80); };
    var both = function () { measure(); update(); };
    both();
    onScroll(update);
    on(W, 'resize', both);
    on(W, 'load', both);
  }

  /* ================= ADD TO CART FEEDBACK =================
     A state, not an animation: the button dims while adding and ticks when done.
     Uses Dawn's own pub/sub, so the cart request itself is never touched. */
  function initCartFeedback() {
    D.querySelectorAll('.product-form__submit').forEach(function (btn) {
      if (btn.dataset.pbBound) return; btn.dataset.pbBound = '1';
      on(btn, 'click', function () {
        btn.classList.add('pb-loading');
        setTimeout(function () { btn.classList.remove('pb-loading'); }, 2500);
      });
    });
    if (typeof W.subscribe === 'function' && typeof W.PUB_SUB_EVENTS !== 'undefined' && !W.__pbCartSub) {
      W.__pbCartSub = W.subscribe(W.PUB_SUB_EVENTS.cartUpdate, function () {
        D.querySelectorAll('.product-form__submit.pb-loading').forEach(function (b) {
          b.classList.remove('pb-loading'); b.classList.add('pb-done');
          setTimeout(function () { b.classList.remove('pb-done'); }, 1600);
        });
      });
    }
  }

  function start() {
    heroEnd = 0;
    initHero();
    initHeader();
    initCartFeedback();
    on(W, 'scroll', scrolled, { passive: true });
  }

  W.PBMotion = {
    __booted: true,
    refresh: function () { teardown(); start(); },
    destroy: teardown,
    reinit: function () { teardown(); start(); }
  };

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  /* Theme editor: a re-rendered section gets a fresh hero */
  D.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector('[data-hstack]');
    if (s) delete s.dataset.pbBound;
    teardown(); start();
  });
})();
